import api from '../../services/reportSubmitted';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('report_submitted');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'Submitted Reports');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}